import React, { Dispatch, SetStateAction, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

type MOStep2Props = {
	setCurrentStep: Dispatch<SetStateAction<number | string>>;
	membershipQuestions: any;
	setMembershipQuestions: Dispatch<any>;
};

export const MOStep2: React.FC<MOStep2Props> = ({
	setCurrentStep,
	membershipQuestions,
	setMembershipQuestions,
}) => {
	const [initialDetails] = useState<any>(membershipQuestions);	

	const validationSchema = Yup.object({
		selectedPackage: Yup.number().required('Please select an age range').nullable(),
	});	

	const optLabel = (name: string) => {
		if(name === "Infant"){
			return "3-7 years old (Infant)";
		}

		if(name === "Junior"){
			return "7–11 years old (Junior)";
		}
		
		if(name === "Primary"){
			return "3-11 years old (Primary)";
		}		
	};

	const handleSubmit = async (values: any) => {
		setMembershipQuestions(values);
		setCurrentStep(3);
	};

	return (
		<>
			<div className="MOSpeechBubbleQuestion">
				<div className="SpeechBubbleQ">
					<h1>What is the age range of your pupils?</h1>
				</div>
			</div>

			<Formik
				initialValues={initialDetails}
				onSubmit={handleSubmit}
				validateOnChange={false}
				validateOnBlur={false}
				validateOnMount={false}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(formik) => {
					let values: any = formik.values;

					return (
						<Form>
							<div className="MOQForm">
								{formik.errors.selectedPackage && <p className="ErrorTxt">{(formik as any).errors.selectedPackage}</p>}
								<div className="RadioBtnsList">
									{values.generalPackages.map((option: any, index: number) => {
										return (
											<div 
												key={option.id}
												className={"RBBlock" + (option.id === values.selectedPackage ? " Checked" : "")}
												onClick={() => {
													formik.setFieldValue("selectedPackage", option.id);
													formik.setFieldValue("ageGroup", option.name);
												}}
											>
												<div className="Checkbox">
													<input id={"MO_Radio_" + index} type="radio" name={"MO_Radio_List"} checked={option.id === values.selectedPackage} readOnly />
													<label className="CustomInput" htmlFor={"MO_Radio_" + index}>
														{optLabel(option.name)}
													</label>
												</div>
											</div>
										);
									})}									
								</div>

								<div className="Btn BtnOrange SubmitBtn" onClick={formik.submitForm}>Next question</div>
								<div className="Btn BtnWhite BackBtn" onClick={() => {
									setCurrentStep(values.selectedLocationLabel.toLowerCase() !== "united kingdom" ? "NonUK" : 1);
								}}>Back</div>
							</div>
						</Form>
					);
				}}
			</Formik>
		</>
	);
};